import { driver } from "driver.js";
import { getTutorialStatus, markTutorialAsSeen, fillCardForm } from './tutorial';

let driverObj = null

window.onload = async function () {
  document.addEventListener('change', (event) => {
    // Check if the event target is the "Don't show this again" checkbox
    if (event.target && event.target.id === 'dont-show-again') {
      handleCheckboxChange(event.target);
    }
  });

  const seen_tutorial = await getTutorialStatus();

  if (seen_tutorial) {
    return;
  }

  loadElements();
  loadDriver();
  loadButtons();
  driverObj.drive(0);  // Start the tour
}

function bindDropdownAdvance(stepSelector) {
  waitForElement(stepSelector).then(btn => {
    btn.addEventListener('click', () => {
      // Check if the step is currently active
      if (btn.classList.contains('driver-active-element')) {
        const nextBtn = document.querySelector('[data-driver-next-button]');
        if (nextBtn) nextBtn.click();
      }
    });
  });
}

function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve) => {
    const start = Date.now();
    const tick = () => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);
      if (Date.now() - start < timeout) requestAnimationFrame(tick);
      else resolve(null);
    };
    tick();
  });
}

async function loadElements() {
  const dropdown = await waitForElement('#actions', 5000);
  if (!dropdown) return;

  // Prevent stacking if loadElements runs again
  if (!dropdown.dataset.tourBound) {
    dropdown.addEventListener('click', updateProgress);
    dropdown.dataset.tourBound = '1';
  }
}

function updateProgress() {
  try {
    driverObj.moveNext();
  }
  catch (err) {
    console.warn('Failed to move tour to next step', err);
  }
}

function loadDriver() {
  // Get all tour elements from the page by description and steps
  let tourDescriptedElements = document.querySelectorAll('[aria-tour-description]')
  let tourSteppedElements = document.querySelectorAll('[aria-tour-step]');

  var tourElements = [...tourDescriptedElements, ...tourSteppedElements];
  var tourSteps = [];
  driverObj = null;

  tourElements.forEach(element => {
    let step = {
      popover: {
        title: element.getAttribute('aria-tour-title'),
        description: element.getAttribute('aria-tour-description'),
        showButtons: ['next', 'previous'],
        disableButtons: [],
      },
    };

    step.afterStep = null
    step.condition = null

    step = configureStep(element, step);

    tourSteps.push(step);
  });

  tourSteps = rearrangeTourSteps(tourSteps);
  driverObj = initDriver(tourSteps)
}

async function loadButtons() {
  document.addEventListener('click', function (e) {
    const tourNextBtn = e.target.closest("[aria-next-on-click]");
    if (tourNextBtn) {
      updateProgress()
    }
  });
}

function configureStep(element, step) {
  if (element.getAttribute('aria-no-element') !== "true") {
    step.element = element;  // Only add the element if aria-tour-step is not 'null'
  }

  if (element.hasAttribute('data-driver-next-hidden')) {
    const { showButtons } = step.popover;
    step.popover.showButtons = showButtons.filter(button => button !== 'next');
  }
  if (element.hasAttribute('data-driver-prev-hidden')) {
    const { showButtons } = step.popover;
    step.popover.showButtons = showButtons.filter(button => button !== 'previous');
  }
  if (element.hasAttribute('data-driver-done-hidden')) {
    const { showButtons } = step.popover;
    step.popover.doneBtnText = "Next →";
  }

  if (element.hasAttribute('data-driver-next-disabled')) {
    if (!step.popover.disableButtons.includes('next')) {
      step.popover.disableButtons.push('next');
    }
  }
  if (element.hasAttribute('data-driver-prev-disabled')) {
    if (!step.popover.disableButtons.includes('previous')) {
      step.popover.disableButtons.push('previous');
    }
  }

  if (element.getAttribute('data-driver-event') == "simulate-form-fill") {
    step.popover.onNextClick = function () {
      driverObj.moveNext()
      fillCardForm()
    }
  }

  if (element.getAttribute('aria-tour-destroy') == "true") {
    step.popover.onNextClick = function () {
      driverObj.moveNext()
      destroyTour();
    }
  }

  const nextBtnText = element.getAttribute('data-driver-next-text');
  const prevBtnText = element.getAttribute('data-driver-prev-text');
  const doneBtnText = element.getAttribute('data-driver-done-text');
  const skipBtnText = element.getAttribute('data-driver-skip-text');

  if (nextBtnText) {
    step.popover.nextBtnText = nextBtnText;
  }

  if (prevBtnText) {
    step.popover.prevBtnText = prevBtnText;
  }

  if (doneBtnText) {
    step.popover.doneBtnText = doneBtnText;
  }

  if (skipBtnText) {
    step.popover.description += `<br><br>
      <label>
          <input type="checkbox" id="dont-show-again" /> ${skipBtnText}
      </label>`

    step.popover.onNextClick = function () {
      const checkbox = document.getElementById('dont-show-again');
      if (checkbox && checkbox.checked) {
        let steps = [
          {
            popover: {
              description: "You can access this tutorial again at anytime by clicking 'Restart Tour' from settings",
              onNextClick: function () {
                destroyTour();
              },
            }
          },
        ]
        steps[0].popover.showButtons = ['next']
        steps[0].popover.doneBtnText = "Finish"
        driverObj = initDriver(steps)
        driverObj.drive(0)
      }
      else {
        updateProgress()
      }
    }
  }

  // Side and alignment directions for the popover in the tour
  const allowedSides = ['left', 'top', 'right', 'bottom'];
  const allowedAligns = ['start', 'center', 'end'];

  const side = element.getAttribute('data-driver-side');
  if (side && allowedSides.includes(side)) {
    step.popover.side = side;
  }

  const align = element.getAttribute('data-driver-align');
  if (align && allowedAligns.includes(align)) {
    step.popover.align = align;
  }

  step.afterStep = element.getAttribute('aria-tour-step-after')

  let condition = element.getAttribute('aria-tour-condition')
  if (condition) {
    step.condition = condition
  }

  return step;
}

function initDriver(tourSteps) {
  let driverObj = window.driver.js.driver({
    showProgress: false,
    allowClose: true,
    smoothScroll: true,
    disableKeyboardControl: true,
    steps: tourSteps,
    popoverClass: 'driverjs-theme'
  });
  return driverObj;
}

async function destroyTour() {
  if (driverObj) {
    driverObj.destroy();
    await markTutorialAsSeen(); // Set seen_tutorial to true
  }
}

function rearrangeByDependencies(tourSteps) {
  const reorderedSteps = [];
  const addedSteps = new Set(); // Track IDs of already added steps

  // Helper function to add steps based on dependencies
  function addStepWithDependencies(step) {
    const id = step.element && step.element.id;

    // Skip if already added by ID
    if (id && addedSteps.has(id)) return;

    const beforeId = step.beforeStep ? step.beforeStep.replace('#', '') : null;
    const afterId = step.afterStep ? step.afterStep.replace('#', '') : null;

    // Process `beforeStep` dependency first, only if it hasn't been added
    if (beforeId) {
      const beforeStep = tourSteps.find(s => s.element && s.element.id === beforeId);
      if (beforeStep && !addedSteps.has(beforeId)) addStepWithDependencies(beforeStep);
    }

    // Add the current step (only if not already added)
    if (!addedSteps.has(id)) {
      reorderedSteps.push(step);
      if (id) addedSteps.add(id);
    }

    // Process `afterStep` dependency afterward, only if it hasn't been added
    if (afterId) {
      const afterStep = tourSteps.find(s => s.element && s.element.id === afterId);
      if (afterStep && !addedSteps.has(afterId)) addStepWithDependencies(afterStep);
    }
  }

  // First pass: Add steps with dependencies in order
  tourSteps.forEach(step => {
    if (step.beforeStep || step.afterStep) addStepWithDependencies(step);
  });

  // Second pass: Add any remaining steps without dependencies
  tourSteps.forEach(step => {
    const id = step.element && step.element.id;
    if (!addedSteps.has(id)) {
      reorderedSteps.push(step);
      if (id) addedSteps.add(id);
    }
  });

  return reorderedSteps;
}

function rearrangeTourSteps(tourSteps) {
  const reorderedSteps = rearrangeByDependencies(tourSteps);

  // Determine the condition of the first step after rearrangement
  const initialCondition = reorderedSteps[0] && reorderedSteps[0].condition;

  if (initialCondition) {
    const uniqueSteps = new Set();
    const filteredSteps = reorderedSteps.filter(step => {
      const id = step.element && step.element.id;
      const isUnique = !uniqueSteps.has(id) && step.condition === initialCondition;

      if (isUnique) {
        uniqueSteps.add(id); // Track the unique step to prevent duplicates
      }

      return isUnique;
    });

    return filteredSteps;
  }

  return reorderedSteps;
}

function handleCheckboxChange(checkbox) {
  const nextButton = document.querySelector('.driver-popover-next-btn');
  if (checkbox && nextButton) {
    if (checkbox.checked) {
      nextButton.textContent = 'Confirm';
    } else {
      const activeElement = document.getElementsByTagName("h2")[0]
      const defaultText = activeElement
        ? activeElement.getAttribute("data-driver-next-text")
        : 'Start Tour 🙌';
      nextButton.textContent = defaultText;
    }
  }
}